"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _objectSpread2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _lodash = _interopRequireDefault(require("lodash"));
var _log = require("@/utils/log");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _cookie = require("@/utils/cookie");
var _user = require("@/api/user");
var _hike = require("@/api/hike");
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { writeGaEvent } from '@/utils/ga'
// import { userEvent } from '@/lifehikes-init-data'
// import { truncate } from '@/filters'
// const defaultValue = []
var _default = exports.default = {
  name: 'HikeBenchmarkScoreChecking',
  data: function data() {
    return {
      fullscreenloading: false,
      isReady: false,
      hike: null,
      myHikeTeams: [],
      tasks: [],
      taskStatus: [],
      raterList: [],
      stages: []
    };
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      var id;
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            id = typeof _this.$route.params.id === 'undefined' ? '' : _this.$route.params.id;
            _this.reportType = _this.$route.query.type === 'benchmark' ? 'benchmark' : 'summit';
            /*
            await this.getHike()
            await this.getRaterList()
            await this.getHikeParticipants()
            await this.getHikeTaskStatus()
            */
            _context.n = 1;
            return _this.initData();
          case 1:
            _this.isReady = true;
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['uuid'])),
  methods: {
    checkPermission: _permission.default,
    initData: function initData() {
      var _this2 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var promise1, promise2, promise3, promise4;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              // map array to promises
              promise1 = _this2.getHike();
              promise2 = _this2.getRaterList();
              promise3 = _this2.getHikeParticipants();
              promise4 = _this2.getHikeTaskStatus(); // wait until all promises are resolved
              _context2.n = 1;
              return Promise.all([promise1, promise2, promise3, promise4]);
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getHike: function getHike() {
      var _this3 = this;
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      (0, _hike.getHikeById)(token, id).then(function (response) {
        _this3.hike = response.data;
        if (_this3.hike.stages) {
          for (var i = 0; i < _this3.hike.stages.length; i++) {
            if (_this3.hike.stages[i].type === _this3.reportType) {
              _this3.stages.push(_this3.hike.stages[i]);
            }
          }
        }
        _this3.loading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('hike-getHikeById-error', error);
        _this3.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    getHikeParticipants: function getHikeParticipants() {
      var _this4 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var token, id;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              id = typeof _this4.$route.params.id === 'undefined' ? '' : _this4.$route.params.id;
              _context3.n = 1;
              return (0, _hike.getParticipant)(token, id).then(function (response) {
                var participants = response.data.rows;
                _this4.myHikeTeams = participants.map(function (p) {
                  return _lodash.default.pick(p, ['uuid', 'familyName', 'givenName', 'email']);
                });
                // console.log('My Teams', this.myHikeTeams)
              }).catch(function (error) {
                (0, _log.showDebugLog)('Hike-getParticipant-API-error', error);
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getRaterList: function getRaterList() {
      var _this5 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var token, query;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              query = {
                page: 1,
                limit: 200,
                role: 'otr-rater',
                sort: 'givenName'
              };
              (0, _user.getUserList)(token, query).then(function (response) {
                // this.list = response.data.items
                _this5.raterList = response.data.rows.map(function (s) {
                  return {
                    uuid: s.uuid,
                    name: "".concat(s.givenName, " ").concat(s.familyName)
                  };
                });
              }).catch(function (error) {
                (0, _log.showDebugLog)('GetUserList-api-error', error);
              });
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getHikeTaskStatus: function getHikeTaskStatus() {
      var _this6 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var token, id;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              id = typeof _this6.$route.params.id === 'undefined' ? '' : _this6.$route.params.id;
              _context5.n = 1;
              return (0, _hike.getTaskStatus)(token, id).then(function (response) {
                //console.log('response', response.data)
                _this6.tasks = response.data.tasks;
                _this6.taskStatus = response.data.jobStatus;
                //console.log('all task', this.tasks)
              }).catch(function (error) {
                (0, _log.showDebugLog)('Hike-getParticipant-API-error', error);
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 1:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getUserProgressHtml: function getUserProgressHtml(uuid, type) {
      var style = 'report-open';
      var symbol = '&#x2718;';
      var html = "";
      var task = _lodash.default.find(this.tasks, function (t) {
        return t.userUuid === uuid && t.stageType === type;
      });
      if (task) {
        style = task.noOfVideoUpload === task.totalNoOfVideo ? 'report-complete' : 'report-open';
        symbol = task.noOfVideoUpload === task.totalNoOfVideo ? "&#10003;" : "&#x2718;";
        html = "<span class=\"".concat(style, "\"> ").concat(symbol, " ").concat(task.noOfVideoUpload, " / ").concat(task.totalNoOfVideo, " Video(s)</span>");
      } else {
        html = "<span class=\"".concat(style, "\"> ").concat(symbol, " 0 / 0 Video(s)</span>");
      }
      return html;
    },
    getTaskStatusHtml: function getTaskStatusHtml(uuid, type) {
      var task = _lodash.default.find(this.tasks, function (t) {
        return t.userUuid === uuid && t.stageType === type;
      });
      var taskStatus = _lodash.default.filter(this.taskStatus, function (t) {
        return t.userUuid === uuid && t.stageType === type;
      });
      var style = 'report-open';
      var symbol = "&#x2718;";
      var assignedRaterName = [];
      var ratingStyle = 'report-open';
      var ratingSymbol = "&#x2718;";
      var noOfRater = 0;
      var noOfAssignedRater = 0;
      // console.log('Task', task)
      // console.log('taskStatus', taskStatus)

      // task assign progress
      if (task) {
        noOfRater = task.noOfRater ? task.noOfRater : 0;
        noOfAssignedRater = task.noOfAssignedRater ? task.noOfAssignedRater : 0;
      }
      if (task) {
        style = noOfRater === noOfAssignedRater ? 'report-complete' : 'report-open';
        symbol = noOfRater === noOfAssignedRater ? "&#10003;" : "&#x2718;";
        assignedRaterName = task.assignTo.map(this.getUserName);
      }

      // rating video progress
      var totalRatingRater = 0;
      var ratingCompleteRater = [];
      for (var i = 0; i < taskStatus.length; i++) {
        if (taskStatus[i].jobStatus === "complete") {
          totalRatingRater += 1;
          ratingCompleteRater.push(this.getUserName(taskStatus[i].raterId));
        }
      }
      if (task) {
        ratingStyle = totalRatingRater === noOfRater ? 'report-complete' : 'report-open';
        ratingSymbol = totalRatingRater === noOfRater ? "&#10003;" : "&#x2718;";
      } else {
        ratingStyle = 'report-open';
        ratingSymbol = '&#x2718;';
      }

      //ratingCompleteRater.join(', ')

      return "<div class=\"".concat(style, "\"> ").concat(symbol, " ").concat(noOfAssignedRater, " / ").concat(noOfRater, " Task(s) - (").concat(assignedRaterName.join(', '), ")</div>") + "<div class=\"".concat(ratingStyle, "\"> ").concat(ratingSymbol, " ").concat(totalRatingRater, " / ").concat(noOfRater, " Rating(s) - (").concat(ratingCompleteRater.join(', '), ")</div>");
    },
    getUserName: function getUserName(uuid) {
      var staff = this.raterList ? this.raterList.find(function (u) {
        return u.uuid === uuid;
      }) : null;
      if (staff) {
        return staff ? staff.name : '-';
      } else {
        return "Not a rater";
      }
    },
    calculateSummaryHtml: function calculateSummaryHtml() {
      var totalBenchmarkTask = 0,
        totalBenchmarkTaskAssign = 0,
        totalBenchmarkRating = 0;
      var totalSummitTask = 0,
        totalSummitTaskAssign = 0,
        totalSummitRating = 0;
      for (var i = 0; i < this.tasks.length; i++) {
        if (this.tasks[i].stageType === 'benchmark') {
          if (this.tasks[i].totalNoOfVideo > 0 && this.tasks[i].totalNoOfVideo === this.tasks[i].noOfVideoUpload) {
            totalBenchmarkTask = totalBenchmarkTask + this.tasks[i].noOfRater;
            totalBenchmarkTaskAssign = totalBenchmarkTaskAssign + this.tasks[i].noOfAssignedRater;
          }
        }
        if (this.tasks[i].stageType === 'summit') {
          if (this.tasks[i].totalNoOfVideo > 0 && this.tasks[i].totalNoOfVideo === this.tasks[i].noOfVideoUpload) {
            totalSummitTask = totalSummitTask + this.tasks[i].noOfRater;
            totalSummitTaskAssign = totalSummitTaskAssign + this.tasks[i].noOfAssignedRater;
          }
        }
      }
      for (var j = 0; j < this.taskStatus.length; j++) {
        if (this.taskStatus[j].stageType === 'benchmark') {
          if (this.taskStatus[j].jobStatus === 'complete') totalBenchmarkRating = totalBenchmarkRating + 1;
        }
        if (this.taskStatus[j].stageType === 'summit') {
          if (this.taskStatus[j].jobStatus === 'complete') totalSummitRating = totalSummitRating + 1;
        }
      }
      return "<div><u>Summary</u></div>" + "<div>Total Tasks(Benchmark): <u> ".concat(totalBenchmarkTask, "</u></div>") + "<div>Total Assigned Tasks(Benchmark): <u>".concat(totalBenchmarkTaskAssign, "</u></div>") + "<div>Total Rated Tasks(Benchmark): <u>".concat(totalBenchmarkRating, "</u></div>") + "<div>-----------------------------------------------------------</div>" + "<div>Total Tasks(Summit): <u>".concat(totalSummitTask, "</u></div>") + "<div>Total Assigned Tasks(Summit): <u>".concat(totalSummitTaskAssign, "</u></div>") + "<div>Total Rated Tasks(Summit): <u>".concat(totalSummitRating, "</u></div>");
    },
    backToHike: function backToHike() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push("/hike/edit/".concat(id));
    }
  }
};